module.exports = __webpack_public_path__ + "img/range-lt.4f409092.png";